module.exports = __webpack_public_path__ + "img/indus-pic-13.e8218e3f.png";